import {
    SAVE_SURGERY_DETAILS,
    SAVE_SURGERY_DETAILS_SUCCESS,
    SAVE_SURGERY_DETAILS_FAILURE,
    RESET_CREATE_UPDATE_SURGERY,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    saveSurgery: {
        data: {},
        statusCode: '',
        statusMessage: '',
    },
    saveSurgeryLoading: false,
};

const createSurgeryReducer = (state = initialState, action) => {
    switch (action.type) {
        case SAVE_SURGERY_DETAILS:
            return {
                ...state,
                saveSurgeryLoading: true,
            };
        case SAVE_SURGERY_DETAILS_SUCCESS:
            return {
                ...state,
                saveSurgery: {
                    data: action.data,
                    statusCode: '10011',
                },
                saveSurgeryLoading: false,
            };
        case SAVE_SURGERY_DETAILS_FAILURE:
            return {
                ...state,
                saveSurgery: {
                    data: {},
                    message: action.data.message,
                    statusCode: '422',
                },
                saveSurgeryLoading: false,
            };
        case RESET_CREATE_UPDATE_SURGERY:
            return initialState;
        default: {
            return { ...state };
        }
    }
};
export default persistReducer(
    {
        key: 'surgerySubmissionKey',
        storage: storage,
        whitelist: ['saveSurgery'],
    },
    createSurgeryReducer
);
